module.exports = __webpack_public_path__ + "static/media/atendimento-bot-meu-porto-seguro.8dbb9c3b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/atendimentoButton/icons/atendimento-bot-meu-porto-seguro.svg
// module id = 1796
// module chunks = 0